"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unifyType = void 0;
const indent_1 = require("../../utils/indent");
const closure_1 = require("../closure");
const ctx_1 = require("../ctx");
const Errors = __importStar(require("../errors"));
const Neutrals = __importStar(require("../neutral"));
const solution_1 = require("../solution");
const unify_1 = require("../unify");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
const value_1 = require("../value");
function unifyType(mod, ctx, left, right) {
    left = (0, solution_1.solutionAdvanceValue)(mod, left);
    right = (0, solution_1.solutionAdvanceValue)(mod, right);
    const success = (0, unify_1.unifyPatternVar)(mod, ctx, Values.Type(), left, right);
    if (success)
        return;
    try {
        unifyTypeAux(mod, ctx, left, right);
    }
    catch (error) {
        if (error instanceof Errors.UnificationError) {
            error.trace.unshift([
                `[unifyType]`,
                (0, indent_1.indent)(`left: ${(0, value_1.formatType)(mod, ctx, left)}`),
                (0, indent_1.indent)(`right: ${(0, value_1.formatType)(mod, ctx, right)}`),
            ].join("\n"));
        }
        throw error;
    }
}
exports.unifyType = unifyType;
function unifyTypeAux(mod, ctx, left, right) {
    if (left["@kind"] === "TypedNeutral" && right["@kind"] === "TypedNeutral") {
        /**
           The `type` in `TypedNeutral` are not used.
        **/
        (0, unify_1.unifyNeutral)(mod, ctx, left.type, left.neutral, right.neutral);
        return;
    }
    if (left["@kind"] === "Type" && right["@kind"] === "Type") {
        return;
    }
    if (left["@kind"] === "String" && right["@kind"] === "String") {
        return;
    }
    if (left["@kind"] === "Trivial" && right["@kind"] === "Trivial") {
        return;
    }
    if ((left["@kind"] === "Pi" && right["@kind"] === "Pi") ||
        (left["@kind"] === "PiImplicit" && right["@kind"] === "PiImplicit")) {
        unifyType(mod, ctx, left.argType, right.argType);
        const name = right.retTypeClosure.name;
        const argType = right.argType;
        const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
        const freshName = (0, freshen_1.freshen)(usedNames, name);
        const v = Values.TypedNeutral(argType, Neutrals.Var(freshName));
        ctx = (0, ctx_1.CtxCons)(freshName, argType, ctx);
        unifyClosure(mod, ctx, right.retTypeClosure, left.retTypeClosure, v, freshName);
        return;
    }
    if (left["@kind"] === "Sigma" && right["@kind"] === "Sigma") {
        unifyType(mod, ctx, left.carType, right.carType);
        const name = right.cdrTypeClosure.name;
        const carType = right.carType;
        const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
        const freshName = (0, freshen_1.freshen)(usedNames, name);
        const v = Values.TypedNeutral(carType, Neutrals.Var(freshName));
        ctx = (0, ctx_1.CtxCons)(freshName, carType, ctx);
        unifyClosure(mod, ctx, right.cdrTypeClosure, left.cdrTypeClosure, v, freshName);
        return;
    }
    if ((0, value_1.isClazz)(left) && (0, value_1.isClazz)(right)) {
        (0, unify_1.unifyClazz)(mod, ctx, left, right);
        return;
    }
    if (left["@kind"] === "Equal" && right["@kind"] === "Equal") {
        unifyType(mod, ctx, left.type, right.type);
        const equalType = left.type;
        (0, unify_1.unify)(mod, ctx, equalType, left.from, right.from);
        (0, unify_1.unify)(mod, ctx, equalType, left.to, right.to);
        return;
    }
    throw new Errors.UnificationError([
        `[unifyType] is not implemented for the pair of type values`,
        (0, indent_1.indent)(`left: ${(0, value_1.formatType)(mod, ctx, left)}`),
        (0, indent_1.indent)(`right: ${(0, value_1.formatType)(mod, ctx, right)}`),
    ].join("\n"));
}
/**

   # unification between two `Sigma`s

   Problem: We we must be able to solve the following equation:

   ```
   solve (A: Type, B: (x: A) -> Type) {
     exists (x: A) B(x) = exists (_: String) String
   }
   ```

   The same problem occurs for unification between two Pis.

   Solution: Handle unification between Sigma specially,
   to generate a const function (x: String) => String for B:

   ```
   { A: String, B: (x: String) => String }
   ```

**/
function unifyClosure(mod, ctx, left, right, v, name) {
    const leftRet = (0, closure_1.closureApply)(left, v);
    const rightRet = (0, closure_1.closureApply)(right, v);
    /**
       If after the application of the closure,
       the result value is `f(name)`,
       then we should unify `f` with the other closure as a function.
    **/
    const leftApTarget = extractApTarget(leftRet, name);
    if (leftApTarget) {
        (0, unify_1.unify)(mod, ctx, leftApTarget.type, leftApTarget, Values.Fn(right));
        return;
    }
    const rightApTarget = extractApTarget(rightRet, name);
    if (rightApTarget) {
        (0, unify_1.unify)(mod, ctx, rightApTarget.type, rightApTarget, Values.Fn(left));
        return;
    }
    unifyType(mod, ctx, leftRet, rightRet);
}
function extractApTarget(value, name) {
    if (value["@kind"] === "TypedNeutral" &&
        value.neutral["@kind"] === "Ap" &&
        value.neutral.target["@kind"] === "PatternVar" &&
        value.neutral.arg.value["@kind"] === "TypedNeutral" &&
        value.neutral.arg.value.neutral["@kind"] === "Var" &&
        value.neutral.arg.value.neutral.name === name) {
        return Values.TypedNeutral(value.neutral.targetType, value.neutral.target);
    }
}
//# sourceMappingURL=unifyType.js.map